import { store } from "../redux/store";
import { sendEmailNotification } from "../redux/emailSlice";
// ✅ Generic function
const sendEmail = async (type, data) => {
    return store.dispatch(sendEmailNotification({
        type,
        data
    }));
};
export const sendDraftForApproval = (data) => sendEmail("DRAFT_EMAIL_APPROVAL", data);
// Subject/preview/audience details are resolved server-side (emailController,
// from campaignId) — this only needs to identify the client/campaign/action.
export const sendDraftEmailReady = (data) => sendEmail("DRAFT_EMAIL_READY", data);
// Draft item already visible to the client — any status/comment action fires
// this instead (subject/preview/audience details also resolved server-side).
export const sendDraftEmailActivity = (data) => sendEmail("DRAFT_EMAIL_ACTIVITY", data);
export const sendPromotionMetrics = (data) => sendEmail("PROMOTION_METRICS", data);
// Fired together (both keys) when a proposal is sent for review while
// visible_to_client is still false — same trigger condition as
// sendDraftEmailReady, just for proposals instead of drafts.
export const sendPromotionCalendarReady = (data) => sendEmail("PROMOTION_CALENDER_READY", data);
// The ONLY key for any status change or comment on a proposal once
// visible_to_client is true — replaces PROMOTION_APPROVED/RESULT_UPDATE/
// CLIENT_UPDATE/AM_UPDATE for proposals. promotionUpdates is built server-side.
export const sendPromotionCalendarActivity = (data) => sendEmail("PROMOTION_CALENDER_ACTIVITY", data);
// ==============================
// 📩 PROPOSAL EMAILS
// ==============================
export const sendProposalForApproval = (data) => sendEmail("SEND_FOR_APPROVAL", data);
export const sendCustomEmail = (type, data) => sendEmail(type, data);
